/**
 * SourceReceipts — the rest of the tweets behind a merged beat (Leg 6, decision C4).
 *
 * Post-clustering the drain mints one beat per EVENT rather than per tweet, so a beat can
 * stand on several source tweets. The body already embeds the canonical (thread-root) one;
 * this embeds the others. Honest provenance: one beat, N receipts — the reader can see the
 * whole event the beat was merged from, not just the announcement we picked to lead with.
 *
 * Renders nothing when the beat did not merge, which is most beats: `sourceTweetIds[]` is
 * absent on single-tweet beats by design. The host computes the list (lib/beat-receipts.ts)
 * and passes only the ids the body does not already show.
 */

'use client';

import React from 'react';
import { TwitterEmbed } from '@/components/ui/SocialEmbed';

interface SourceReceiptsProps {
  /** Tweet ids to embed, canonical-first order, already deduped against the body. */
  tweetIds: string[];
}

export default function SourceReceipts({ tweetIds }: SourceReceiptsProps) {
  if (!Array.isArray(tweetIds) || tweetIds.length === 0) return null;

  return (
    <div className="mt-6 border-t-[0.5px] border-divider pt-4">
      <div className="mb-2 font-mono text-[11px] uppercase tracking-[0.14em] text-parchment-dim">
        Also in this event
      </div>
      {tweetIds.map((id) => (
        // TwitterEmbed keys off the URL; twitter.com (not x.com) is the form react-tweet
        // and the body's own embeds normalize to.
        <TwitterEmbed key={id} tweetUrl={`https://twitter.com/i/status/${id}`} />
      ))}
    </div>
  );
}
